/* Emir ICE — menu : méga-menu ordinateur + tiroir plein écran mobile (refonte, 2026-10-13)
   Balisage : snippets/eix-menu-*.liquid. Style : assets/eix-menu.css. Chargé depuis sections/header.liquid.

   Ordinateur (≥ 799 px) : au survol (intention : petit délai, la souris peut traverser en diagonale), au clic ou au focus clavier d'une entrée,
     un panneau pleine largeur s'ouvre sous la barre. Clavier : flèches gauche/droite entre les entrées, flèche bas = entrer dans le panneau,
     Échap = fermer et rendre le focus, Tab parcourt le panneau puis passe à la suite de la barre. aria-expanded sur chaque entrée.
     Toucher : 1er appui = ouvrir, 2e appui = suivre le lien de l'entrée.
   Mobile (≤ 798 px) : tiroir plein écran (role="dialog", aria-modal), piège de focus, Échap, page de fond figée, accordéons exclusifs.
   Images : chargées à la première ouverture (data-src → src).
   InstantClick remplace le <body> sans recharger : les écouteurs globaux ne sont posés qu'UNE fois, init() se rejoue à chaque page
   (événements « change » d'InstantClick et « instantclick:newpage ») et ne garde aucun état attaché à un élément. */
(function () {
  'use strict';
  if (window.__eixMenu) { window.__eixMenu.init(); return; }

  var doc = document;
  var html = doc.documentElement;
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 799px)') : { matches: true };
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var S = { open: null, openT: 0, closeT: 0, y: 0, drawer: null, opener: null, uid: 0, inerted: [], returnTo: null };

  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function desktop() { return mqDesk.matches; }
  function rootOf(el) { return closest(el, '.main_nav'); }
  function topOf(root, i) { return root ? root.querySelector('[data-eix-top="' + i + '"]') : null; }
  function panelOf(root, i) { return root ? root.querySelector('.eix-mp[data-eix-panel="' + i + '"]') : null; }
  function tops(root) { return qa('[data-eix-top]', root); }
  function focusVisible(el) { try { return el.matches(':focus-visible'); } catch (e) { return true; } }

  /* ---------- images : première ouverture ---------- */
  function loadImages(scope) {
    qa('img.eix-mlz[data-src]', scope).forEach(function (img) {
      var ok = function () { img.classList.add('is-ok'); };
      img.addEventListener('load', ok, { once: true });
      img.addEventListener('error', ok, { once: true });
      var set = img.getAttribute('data-srcset');
      if (set) img.setAttribute('srcset', set);
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
      if (img.complete && img.naturalWidth) ok();
    });
  }

  /* ---------- identifiants uniques (l'en-tête collant du thème est un clone du menu) ---------- */
  function wire(root) {
    if (!root || root.getAttribute('data-eix-w')) return;
    root.setAttribute('data-eix-w', '1');
    var n = ++S.uid;
    tops(root).forEach(function (t) {
      var i = t.getAttribute('data-eix-top');
      var p = panelOf(root, i);
      if (!p) return;
      t.id = 'eix-t' + n + '-' + i;
      p.id = 'eix-p' + n + '-' + i;
      t.setAttribute('aria-controls', p.id);
      p.setAttribute('aria-labelledby', t.id);
    });
  }

  /* ---------- voile sous l'en-tête ---------- */
  function scrim() {
    var s = doc.querySelector('.eix-m-scrim');
    if (!s && doc.body) {
      s = doc.createElement('div');
      s.className = 'eix-m-scrim';
      s.setAttribute('aria-hidden', 'true');
      doc.body.appendChild(s);
    }
    return s;
  }

  /* ---------- panneaux ordinateur ---------- */
  function isOpenAt(root, i) { return !!(S.open && S.open.root === root && String(S.open.i) === String(i)); }

  function place(root, panel) {
    var wrap = closest(root, '.main_nav_wrapper') || root;
    var r = wrap.getBoundingClientRect();
    var bottom = Math.max(0, Math.round(r.bottom));
    panel.style.setProperty('--eix-mp-max', Math.max(300, window.innerHeight - bottom - 14) + 'px');
    html.style.setProperty('--eix-m-top', bottom + 'px');
  }

  function openPanel(root, i, how) {
    var t = topOf(root, i), p = panelOf(root, i);
    if (!t || !p || !desktop()) return;
    if (isOpenAt(root, i)) return;
    wire(root);
    closeEntry(S.open, true);
    clearTimeout(S.openT); clearTimeout(S.closeT);
    place(root, p);
    loadImages(p);
    p.scrollTop = 0;
    p.classList.add('is-open');
    t.setAttribute('aria-expanded', 'true');
    S.open = { root: root, i: i, top: t, panel: p, how: how || '' };
    S.y = window.pageYOffset || 0;
    var s = scrim(); if (s) s.classList.add('is-on');
  }

  function closeEntry(o, keepScrim) {
    if (!o) return;
    o.panel.classList.remove('is-open');
    o.top.setAttribute('aria-expanded', 'false');
    if (S.open === o) S.open = null;
    if (!keepScrim) { var s = doc.querySelector('.eix-m-scrim'); if (s) s.classList.remove('is-on'); }
  }

  function closeAll(giveFocusBack) {
    clearTimeout(S.openT); clearTimeout(S.closeT);
    var o = S.open;
    closeEntry(o, false);
    qa('.eix-mp.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    qa('[data-eix-top][aria-expanded="true"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    var s = doc.querySelector('.eix-m-scrim'); if (s) s.classList.remove('is-on');
    if (giveFocusBack && o && o.top) focusEl(o.top, true);
  }

  function scheduleClose(ms) {
    clearTimeout(S.closeT);
    S.closeT = setTimeout(function () { closeAll(false); }, ms);
  }

  /* éléments focalisables d'un conteneur (visibles, hors « Voir tout » refermé) */
  function focusables(box) {
    return qa('a[href]:not([tabindex="-1"]), button:not([disabled]), summary, input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', box).filter(function (el) {
      if (el.getAttribute('aria-hidden') === 'true') return false;
      var det = closest(el, 'details:not([open])');
      if (det && !(el.tagName === 'SUMMARY' && el.parentNode === det)) return false;
      if (!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)) return false;
      var cs = window.getComputedStyle(el);
      return cs.visibility !== 'hidden';
    });
  }
  /* quiet : on rend le focus à une entrée (après Échap, Maj+Tab...) sans que ce focus ne rouvre son panneau */
  function focusEl(el, quiet) {
    if (!el) return;
    S.quiet = !!quiet;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    S.quiet = false;
  }

  /* l'élément qui suit une entrée dans la barre (entrée suivante, ou recherche après la dernière) */
  function afterTop(top) {
    var li = closest(top, 'li');
    var nx = li ? li.nextElementSibling : null;
    while (nx) {
      var f = focusables(nx);
      if (f.length) return f[0];
      nx = nx.nextElementSibling;
    }
    return null;
  }

  /* ---------- survol (intention) ---------- */
  doc.addEventListener('pointerover', function (e) {
    if (!desktop() || e.pointerType === 'touch') return;
    var t = closest(e.target, '[data-eix-top]');
    if (t) {
      var root = rootOf(t), i = t.getAttribute('data-eix-top');
      clearTimeout(S.closeT); clearTimeout(S.openT);
      if (isOpenAt(root, i)) return;
      var delay = S.open ? 140 : 70;
      S.openT = setTimeout(function () { openPanel(root, i, 'hover'); }, delay);
      return;
    }
    if (closest(e.target, '.eix-mp')) { clearTimeout(S.closeT); clearTimeout(S.openT); }
  }, true);

  doc.addEventListener('pointerout', function (e) {
    if (!desktop() || e.pointerType === 'touch') return;
    var from = closest(e.target, '[data-eix-top]') || closest(e.target, '.eix-mp');
    if (!from) return;
    var to = e.relatedTarget;
    if (to && from.contains && from.contains(to)) return;
    clearTimeout(S.openT);
    var toEl = to ? (closest(to, '[data-eix-top]') || closest(to, '.eix-mp')) : null;
    if (toEl) return;
    if (S.open) scheduleClose(260);
  }, true);

  /* ---------- clic ---------- */
  doc.addEventListener('click', function (e) {
    var tgt = e.target;
    /* tiroir mobile : bouton « Menu » du thème */
    var mob = closest(tgt, '.mobile_nav');
    if (mob && doc.querySelector('[data-eix-dr]') && !desktop()) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (S.drawer && S.drawer.classList.contains('is-open')) closeDrawer(true); else openDrawer(mob);
      return;
    }
    if (closest(tgt, '[data-eix-dr-close]')) { e.preventDefault(); closeDrawer(true); return; }
    var acb = closest(tgt, '[data-eix-ac-b]');
    if (acb) { e.preventDefault(); toggleAc(closest(acb, '[data-eix-ac]')); return; }
    var dlink = closest(tgt, '.eix-mdr a[href]');
    if (dlink && S.drawer && S.drawer.classList.contains('is-open')) {
      /* tel: et liens d'ancre : le tiroir se ferme aussi ; InstantClick remplace la page de toute façon */
      setTimeout(function () { closeDrawer(false); }, 0);
      return;
    }
    if (!desktop()) return;

    var t = closest(tgt, '[data-eix-top]');
    if (t) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var root = rootOf(t), i = t.getAttribute('data-eix-top');
      if (!isOpenAt(root, i)) { e.preventDefault(); e.stopPropagation(); clearTimeout(S.openT); openPanel(root, i, 'click'); }
      return; /* déjà ouvert : on suit le lien de l'entrée */
    }
    if (closest(tgt, '.eix-mp a[href]')) { closeAll(false); return; }
    if (S.open && !closest(tgt, '.eix-mp')) closeAll(false);
  }, true);

  /* ---------- clavier ---------- */
  doc.addEventListener('keydown', function (e) {
    var k = e.key;
    if (S.drawer && S.drawer.classList.contains('is-open')) { drawerKey(e); return; }
    var mob = closest(e.target, '.mobile_nav');
    if (mob && (k === 'Enter' || k === ' ') && doc.querySelector('[data-eix-dr]') && !desktop()) {
      e.preventDefault(); e.stopPropagation();
      openDrawer(mob);
      return;
    }
    if (!desktop()) return;
    var t = closest(e.target, '[data-eix-top]');
    var p = closest(e.target, '.eix-mp');
    if (t) { topKey(e, t); return; }
    if (p) { panelKey(e, p); return; }
    if (k === 'Escape' && S.open) { closeAll(true); }
  }, false);

  function topKey(e, t) {
    var root = rootOf(t), i = t.getAttribute('data-eix-top'), k = e.key;
    var list = tops(root), pos = list.indexOf(t), p = panelOf(root, i);
    if (k === 'ArrowRight' || k === 'ArrowLeft' || k === 'Home' || k === 'End') {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      e.preventDefault();
      var n = k === 'Home' ? 0 : k === 'End' ? list.length - 1 : (pos + (k === 'ArrowRight' ? 1 : -1) + list.length) % list.length;
      focusEl(list[n]);
      return;
    }
    if (k === 'ArrowDown') {
      e.preventDefault();
      openPanel(root, i, 'key');
      var f = p ? focusables(p) : [];
      if (f.length) focusEl(f[0]);
      return;
    }
    if (k === ' ') {
      e.preventDefault();
      if (isOpenAt(root, i)) closeAll(false); else openPanel(root, i, 'key');
      return;
    }
    if (k === 'Escape') { if (S.open) { e.preventDefault(); closeAll(false); } return; }
    if (k === 'Tab' && !e.shiftKey && isOpenAt(root, i) && p) {
      var f2 = focusables(p);
      if (f2.length) { e.preventDefault(); focusEl(f2[0]); }
    }
  }

  function panelKey(e, p) {
    var k = e.key;
    var root = rootOf(p), i = p.getAttribute('data-eix-panel'), t = topOf(root, i);
    var f = focusables(p), pos = f.indexOf(doc.activeElement);
    if (k === 'Escape') { e.preventDefault(); closeAll(false); focusEl(t, true); return; }
    if (k === 'Tab') {
      if (e.shiftKey && pos <= 0) { e.preventDefault(); focusEl(t, true); return; }
      if (!e.shiftKey && pos === f.length - 1) {
        var nx = afterTop(t);
        closeAll(false);
        if (nx) { e.preventDefault(); focusEl(nx); }
      }
      return;
    }
    if (k === 'ArrowDown' || k === 'ArrowUp') {
      if (closest(e.target, 'select, input')) return;
      e.preventDefault();
      var n = pos + (k === 'ArrowDown' ? 1 : -1);
      if (n < 0) { focusEl(t, true); return; }
      if (n >= f.length) n = f.length - 1;
      focusEl(f[n]);
      return;
    }
    if (k === 'Home' || k === 'End') { if (f.length) { e.preventDefault(); focusEl(k === 'Home' ? f[0] : f[f.length - 1]); } }
  }

  doc.addEventListener('focusin', function (e) {
    if (!desktop()) return;
    var t = closest(e.target, '[data-eix-top]');
    if (t) {
      if (S.quiet || !focusVisible(e.target)) return;
      openPanel(rootOf(t), t.getAttribute('data-eix-top'), 'focus');
    }
  }, true);

  doc.addEventListener('focusout', function (e) {
    if (!S.open || !desktop()) return;
    var to = e.relatedTarget;
    if (!to) return; /* clic sur une zone non focalisable, ou fenêtre masquée : le clic décide */
    if (closest(to, '[data-eix-top]') || closest(to, '.eix-mp')) return;
    scheduleClose(60);
  }, true);

  window.addEventListener('scroll', function () {
    if (S.open && Math.abs((window.pageYOffset || 0) - S.y) > 80) closeAll(false);
  }, { passive: true });

  /* « Voir tout » ouvert : la fin de la liste est amenée dans la zone visible (le panneau ou le tiroir défile) */
  doc.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details.eix-mmore') || !d.open) return;
    var box = closest(d, '.eix-mp') || closest(d, '.eix-mdr__scroll');
    var list = d.querySelector('ul');
    if (!box || !list) return;
    window.setTimeout(function () {
      var br = box.getBoundingClientRect(), lr = list.getBoundingClientRect();
      var over = lr.bottom - (br.bottom - 20);
      if (over > 2) { try { box.scrollBy({ top: over, behavior: mqReduce.matches ? 'auto' : 'smooth' }); } catch (err) { box.scrollTop += over; } }
    }, 60);
  }, true);

  /* ---------- tiroir mobile ---------- */
  function setExpanded(v) {
    qa('.mobile_nav').forEach(function (m) { m.setAttribute('aria-expanded', v ? 'true' : 'false'); });
  }

  /* le reste de la page n'est plus atteignable (lecteurs d'écran, clavier) tant que le tiroir est ouvert */
  function setInert(on) {
    if (on) {
      var d = S.drawer, n = d;
      S.inerted = [];
      while (n && n !== doc.body) {
        var par = n.parentNode;
        if (!par) break;
        Array.prototype.forEach.call(par.children, function (sib) {
          if (sib !== n && sib.tagName !== 'SCRIPT' && sib.tagName !== 'STYLE' && sib.tagName !== 'LINK' && !sib.hasAttribute('inert')) { sib.setAttribute('inert', ''); S.inerted.push(sib); }
        });
        n = par;
      }
    } else {
      S.inerted.forEach(function (el) { el.removeAttribute('inert'); });
      S.inerted = [];
    }
  }

  function openDrawer(opener) {
    var d = doc.querySelector('[data-eix-dr]');
    if (!d) return;
    closeAll(false);
    S.drawer = d; S.opener = opener || null; S.returnTo = doc.activeElement;
    loadImages(d.querySelector('.eix-mdr__tiles'));
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    html.classList.add('eix-mdr-open');
    setExpanded(true);
    setInert(true);
    var x = d.querySelector('[data-eix-dr-close]');
    window.requestAnimationFrame(function () { focusEl(x); });
  }

  function closeDrawer(giveFocusBack) {
    var d = S.drawer || doc.querySelector('[data-eix-dr]');
    if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }
    html.classList.remove('eix-mdr-open');
    setExpanded(false);
    setInert(false);
    if (giveFocusBack) {
      var back = S.opener && doc.contains(S.opener) ? S.opener : qa('.mobile_nav')[0];
      focusEl(back);
    }
    S.drawer = null; S.opener = null;
  }

  function drawerKey(e) {
    var d = S.drawer, k = e.key;
    if (k === 'Escape') { e.preventDefault(); closeDrawer(true); return; }
    if (k !== 'Tab') return;
    var f = focusables(d);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], a = doc.activeElement;
    if (e.shiftKey && (a === first || !d.contains(a))) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && (a === last || !d.contains(a))) { e.preventDefault(); focusEl(first); }
  }

  function toggleAc(ac) {
    if (!ac) return;
    var b = ac.querySelector('[data-eix-ac-b]');
    var willOpen = !ac.classList.contains('is-open');
    if (willOpen) {
      var group = closest(ac, '.eix-mdr__acc');
      qa('[data-eix-ac].is-open', group || doc).forEach(function (o) {
        if (o === ac) return;
        o.classList.remove('is-open');
        var ob = o.querySelector('[data-eix-ac-b]'); if (ob) ob.setAttribute('aria-expanded', 'false');
      });
    }
    ac.classList.toggle('is-open', willOpen);
    if (b) b.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen) {
      loadImages(ac);
      setTimeout(function () {
        var sc = closest(ac, '.eix-mdr__scroll');
        if (!sc) return;
        var r = ac.getBoundingClientRect(), sr = sc.getBoundingClientRect();
        var delta = r.top - sr.top - 8;
        if (Math.abs(delta) > 4) { try { sc.scrollBy({ top: delta, behavior: mqReduce.matches ? 'auto' : 'smooth' }); } catch (err) { sc.scrollTop += delta; } }
      }, mqReduce.matches ? 0 : 120);
    }
  }

  /* ---------- initialisation (rejouée à chaque page InstantClick) ---------- */
  function hoistCss() {
    var l = doc.querySelector('body link[href*="eix-menu.css"]');
    if (l && doc.head && !doc.head.querySelector('link[href*="eix-menu.css"]')) {
      var c = doc.createElement('link');
      c.rel = 'stylesheet'; c.href = l.getAttribute('href');
      doc.head.appendChild(c);
    }
  }

  function init() {
    clearTimeout(S.openT); clearTimeout(S.closeT);
    S.open = null; S.drawer = null; S.opener = null; S.inerted = [];
    html.classList.remove('eix-mdr-open');
    qa('.eix-mp.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    qa('[data-eix-top][aria-expanded="true"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    qa('[data-eix-dr].is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    var sc0 = doc.querySelector('.eix-m-scrim'); if (sc0) sc0.classList.remove('is-on');
    hoistCss();
    scrim();
    qa('.main_nav').forEach(wire);
    setExpanded(false);
  }

  if (mqDesk.addEventListener) {
    mqDesk.addEventListener('change', function () { closeAll(false); closeDrawer(false); });
  }
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) { closeAll(false); closeDrawer(false); } });

  window.__eixMenu = { init: init, openPanel: openPanel, closeAll: closeAll, openDrawer: openDrawer, closeDrawer: closeDrawer };

  function boot() {
    init();
    doc.addEventListener('instantclick:newpage', init);
    if (window.InstantClick && typeof window.InstantClick.on === 'function') {
      try { window.InstantClick.on('change', init); } catch (e) {}
    }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
